import { render, staticRenderFns } from "./Powerbox.vue?vue&type=template&id=058b85ac&scoped=true"
import script from "./Powerbox.vue?vue&type=script&lang=js"
export * from "./Powerbox.vue?vue&type=script&lang=js"
import style0 from "./Powerbox.vue?vue&type=style&index=0&id=058b85ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b85ac",
  null
  
)

export default component.exports